module.exports = __webpack_public_path__ + "static/media/farm_pharm_3.00e66acf.jpg";